import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as vehiclesActions from '../../../../Transport/redux/actions/vehiclesActions';
// import * as filterActions from '../../../../Transport/redux/actions/filters';
import { Avatar, Icon, Radio, Table, Typography } from 'antd';
import { API } from '../../../../../common/api/constants';
// import ChooseVehiclesFilters from '../Filters/Filters';
import TablePageSize from '../../../../../common/components/TablePageSize';
import './SelectVehicles.css';
const { getAllVehicles } = vehiclesActions; // , resetFiltersVehicles
// const { searchVehicles, updateFilterFieldsVehicles } = filterActions;

const { Text } = Typography;
let tablePlaceholder = <Icon type="loading" style={{ fontSize: 44 }} spin />;

const VehiclesTable = props => {
  const { serviceType } = props;
  useEffect(() => {
    dispatch(getAllVehicles({serviceType}));
  }, [serviceType]);
  const [pages, setPages] = useState(3);
  const dispatch = useDispatch();
  const { vehicles } = useSelector(state => state.Transport.Vehicles); // , filters
  // const { fields: data } = filters;
  const vehiclesList = vehicles && vehicles.actualVehicles;
  function renderColumns() {
    return [
      {
        title: 'Наименование',
        dataIndex: 'vehicle',
        key: 'title',
        render: vehicle => (
          <div className="photoColumn">
            <Avatar
              shape="square"
              size="large"
              src={
                vehicle.photo
                  ? `${API.replace('/api', '')}${vehicle.photo}`
                  : null
              }
            />
            <span id="columnHeader">
              {vehicle.brand && vehicle.brand}
              <br />
              <Text type="secondary">{vehicle.model && vehicle.model}</Text>
            </span>
          </div>
        ),
        sorter: (a, b) => {
          return a.vehicle && a.vehicle.brand.localeCompare(b.vehicle.brand);
        },
      },
      {
        title: 'Год',
        dataIndex: 'year',
        key: 'productionYear',
        render: year => <span id="columnHeader">{year && year}</span>,
        sorter: (a, b) => {
          return a.year.localeCompare(b.year);
        },
      },
      {
        title: 'Рег. знак',
        dataIndex: 'registerSignAndRegion',
        key: 'registerSignAndRegion',
        render: reg_num => <span id="columnHeader">{reg_num && reg_num}</span>,
        sorter: (a, b) => {
          return a.registerSignAndRegion.localeCompare(b.registerSignAndRegion);
        },
      },
      {
        title: 'Мест',
        dataIndex: 'passengerCapacity',
        key: 'passengerCapacity',
        render: places => <span id="columnHeader">{places && places}</span>,
        sorter: (a, b) => {
          return a.passengerCapacity - b.passengerCapacity;
        },
      },
      // {
      //   title: 'Ставка',
      // },
      // {
      //   title: 'Дата ближ. подачи',
      // },
    ];
  }
  /* todo next release
  function resetFilters() {
    dispatch(resetFiltersVehicles());
    dispatch(getAllVehicles());
  }
  function onChangeSearch(e) {
    const { value } = e.target;
    dispatch(searchVehicles(value));
  }
  function handleFiltersChange(values) {
    const val = Object.keys(values).reduce((acc, key) => {
      if (values[key]) {
        if (Array.isArray(values[key]) && values[key].length === 0) {
          return acc;
        }
        acc[key] = values[key];
      }
      return acc;
    }, {});
    dispatch(updateFilterFieldsVehicles(val));
  }
  */
  function onRow(row) {
    return {
      onClick: () => {
        props.selectVehicle(row);
      },
    };
  }
  function changePaginationSize(e) {
    setPages(Number(e));
  }
  return (
    <div className="basicForm" style={{ marginBottom: 64 }}>
      <div className="vehicles">
        <div className="vehicles__header">
          <div className="vehicles__types">
            <Radio.Group defaultValue="active" size="large">
              <Radio.Button
                className="button button_active"
                key="0"
                value="active"
              >
                Всего ТС: {vehiclesList.length}
              </Radio.Button>
            </Radio.Group>
          </div>
        </div>
        <div className="vehicles__wrap">
          {/* todo next release <ChooseVehiclesFilters
            {...props}
            onChangeSearch={onChangeSearch}
            resetFilters={resetFilters}
            handleFiltersChange={handleFiltersChange}
            data={data}
          />*/}
          <div className="employees__table">
            <Table
              dataSource={vehiclesList}
              pagination={{
                pageSize: pages,
              }}
              locale={{
                emptyText: vehicles.isLoading
                  ? tablePlaceholder
                  : 'Тех. средств нет',
              }}
              rowKey="key"
              onRow={onRow}
              columns={renderColumns()}
            />
            {vehiclesList.length > 0 ? (
              <TablePageSize
                pages={pages}
                changePaginationSize={changePaginationSize}
              />
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default VehiclesTable;
